import React from 'react';
import { useParams } from 'react-router-dom';
 const equipmentData = [
  {
    id: "debroussailleuse",
    title: "tête de débroussailleuse",
    subtitle: "multifils-attilina",
    price: "8000 FCFA HT",
    image: "images/equipment-images/tete-de-debroussailleuse-multifils-attilina.jpg"
  },
  {
    id: "fil-debroussaillage",
    title: "fil de débroussaillage",
    subtitle: "pro ellipse bruit",
    price: "9000 FCFA HT",
    image: "images/equipment-images/fil-de-debroussaillage-pro-ellipse-bruit-reduit-25mm-vert-et-noir-blister-de-65m.jpg"
  },
  {
    id: "piquet-de-vigne",
    title: "piquet de vigne",
    subtitle: "intermédiaire",
    price: "11500 FCFA",
    image: "images/equipment-images/piquet-vigne-intermediaire-encoches-lonneo-e01-galva-z275-ep-15-mm-long-180-m-lot-200-unites.jpg"
  },
  {
    id: "ultrason-solaire",
    title: "ultrason solaire",
    subtitle: "répulsif de gibier",
    price: "11500 FCFA",
    image: "images/equipment-images/repulsif-gibier-ultrason-solaire-doxmand-dual-surface-couverte-2-ha.jpg"
  }
  ];
const EquipmentDetails = () => {
  const { id } = useParams();
  const equipment = equipmentData.find(item => item.id === id);

  if (!equipment) return <div>Équipement non trouvé.</div>;

  return (
    <div className="container py-4">
      <h2 className="mb-3">{equipment.title}</h2>
      <img
        src={`/${equipment.image}`}
        alt={equipment.title}
        className="img-fluid mb-4"
        style={{ maxHeight: '400px', objectFit: 'cover' }}
      />
      <h5>{equipment.subtitle}</h5>
      <p className="lead">{equipment.price}</p>
      <p>description</p>
    </div>
  );
};

export default EquipmentDetails;
